import { useEffect, useState } from "react";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { InstanceForm, enregistrerInstance, instanceValide, instanceVide } from "./InstanceForm";
import { errMsg } from "@/lib/api";
import { numeroLisible } from "@/lib/colisCode";

/** Ajout d'une instance sur une fiche colis. */
export function InstanceDialog({ open, colis, motifs, onClose, onSaved }) {
  const [v, setV] = useState(instanceVide());
  const [busy, setBusy] = useState(null); // null | "instance" | "n/total"

  useEffect(() => { if (open) { setV(instanceVide()); setBusy(null); } }, [open]);

  const enregistrer = async () => {
    setBusy("instance");
    try {
      const { fiche, inst, erreurs } = await enregistrerInstance(colis.id, v, setBusy);
      erreurs.forEach((e) => toast.error(errMsg(e)));
      toast.success(`Instance ajoutée : ${inst.motif_label}${v.photos.length ? ` (${v.photos.length - erreurs.length} photo(s))` : ""}`);
      onSaved(fiche);
    } catch (e) { toast.error(errMsg(e)); } finally { setBusy(null); }
  };

  return (
    <Dialog open={open} onOpenChange={(o) => !o && !busy && onClose()}>
      <DialogContent className="sm:max-w-lg max-h-[92dvh] overflow-y-auto" data-testid="instance-dialog">
        <DialogHeader>
          <DialogTitle>Ajouter une instance</DialogTitle>
          <DialogDescription>Colis {numeroLisible(colis?.numero)} — pourquoi n'a-t-il pas pu être livré ?</DialogDescription>
        </DialogHeader>
        <InstanceForm motifs={motifs} value={v} onChange={setV} />
        <DialogFooter>
          <Button type="button" variant="ghost" onClick={onClose} disabled={!!busy}>Annuler</Button>
          <Button onClick={enregistrer} disabled={!instanceValide(motifs, v) || !!busy} data-testid="instance-enregistrer">
            {busy && <Loader2 size={14} className="animate-spin" />}
            {busy && busy !== "instance" ? `Envoi des photos ${busy}…` : "Enregistrer"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
